"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompactKetteUnsafe = exports.isCompactKette = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const isCompactKette = (whatever, ketteSerieType) => (0, echain_shared_modelling_1.isWithRequired)(whatever, {
    KetteSerieType: (v) => v === ketteSerieType,
    Id: true,
    ArtNr: true,
});
exports.isCompactKette = isCompactKette;
const isCompactKetteUnsafe = (whatever, ketteSerieType) => whatever.KetteSerieType === ketteSerieType;
exports.isCompactKetteUnsafe = isCompactKetteUnsafe;
//# sourceMappingURL=CompactKette.js.map